import { Fragment, MouseEvent } from 'react';
import Link from 'next/link';
import { RightOutlined } from '@ant-design/icons';
import { Anchor, Col, Row } from 'antd';

import EmptyC from 'src/components/Layout/Empty';
import { dummyCareerData, dummyCareerHome } from 'src/utils/dummy/career';

import classes from './index.module.css';

const { Link: AntLink } = Anchor;

const PageContainer = () => {
	const careerBreadCrumbs: any = [
		{
			label: 'Karier',
			navigatePath: null,
		},
	];

	const handleAnchorClick = (e: MouseEvent<HTMLElement>) => {
		e.preventDefault();
	};

	return (
		<div className={classes['career-wrap']}>
			<div className={classes.banner}>
				<div className="container">
					<div className={classes['content-head']}>
						<h3 className={classes['page-title']}>Karier</h3>
						<div className={classes['breadcrumb-wrap']}>
							<div className={`${classes.breadcrumb}`}>
								<Link href="/" className={classes['breadcrumb-link']}>
									Home
								</Link>

								{careerBreadCrumbs?.map((item: any, i: number) => {
									if (item.navigatePath) {
										return (
											<Fragment key={i}>
												<RightOutlined className={classes['icon-arrow']} />
												<Link href={item.navigatePath} className={classes['breadcrumb-link']}>
													{item.label}
												</Link>
											</Fragment>
										);
									}

									return (
										<Fragment key={i}>
											<RightOutlined className={classes['icon-arrow']} />
											<span key={item.label} className={classes['static-label']}>
												{item.label}
											</span>
										</Fragment>
									);
								})}
							</div>
						</div>
						<h1 className={classes['text-intro']}>
							Kami menawarkan kesempatan dan tantangan baru untuk kariermu.
						</h1>
						<h3 className={classes.desc}>
							Kami membuka kesempatan bagi kamu untuk bergabung dan mengisi posisi-posisi strategis
							di KlikDokter.
						</h3>
						<h3 className={classes.desc}>
							Kamu dapat memilih bidang yang sesuai dengan talenta serta latar belakang akademis dan
							profesionalmu.
						</h3>
						<div className={classes['button-join']}>
							<Anchor affix={false} onClick={handleAnchorClick}>
								<AntLink href="#positions" title="Gabung Dengan KlikDokter" />
							</Anchor>
						</div>
					</div>
				</div>
			</div>
			<div className="container">
				{dummyCareerData?.length > 0 && (
					<div className={classes['career-content']}>
						<h3 className={classes['content-title']}>Kelebihan KlikDokter</h3>
						<h1 className={classes['content-main-title']}>Kenapa bergabung dengan KlikDokter?</h1>
						<Row className={classes['career-benefits']} gutter={0}>
							{dummyCareerHome.map((x: any, i: any) => {
								return (
									<Col md={12} lg={10} xl={8} key={i}>
										<div className={classes['card-benefit']}>
											<div className={classes.head}>
												<span>{x.label}</span>
											</div>
											<div className={classes.body}>
												<ul className={classes.bodyList}>
													{x.listDetail.map((listDetail: any) => (
														<li key={listDetail}> {listDetail} </li>
													))}
												</ul>
											</div>
										</div>
									</Col>
								);
							})}
						</Row>
						<div className={classes['positions-wrap']} id="positions">
							<div className={classes['guide-group']}>
								<h3 className={classes['guide-desc']}>Posisi yang dibutuhkan</h3>
								<h1 className={classes['guide-main']}>Bergabung dengan tim hebat kami</h1>
							</div>
							<div className={classes['position-list']}>
								{dummyCareerData.map((item: any, i: any) => {
									return (
										<Row className={classes['position-card']} key={i}>
											<Col className={classes['job-title']} xs={12} sm={6} md={6}>
												{item.label}
											</Col>
											<Col className={classes['job-type']} xs={12} sm={6} md={6}>
												{item.statusEmployee}
											</Col>
											<Col className={classes['job-team']} xs={12} sm={6} md={8}>
												<div className={classes['team-label']}>{item.divEmployee}</div>
											</Col>
											<Col className={classes['job-link-btn']} xs={12} sm={6} md={4}>
												<Link href={`/karier/${item.id}`} className={classes['link-button']}>
													Lihat Detail
												</Link>
											</Col>
										</Row>
									);
								})}
							</div>
							{/* <div className={classes.loader}>
							<Button className={classes['load-more-button']}>Muat Lebih Banyak</Button>
						</div> */}
						</div>
					</div>
				)}
				{dummyCareerData?.length === 0 && (
					<div className={classes['career-content']} id="positions">
						<div className={classes['positions-wrap']}>
							<EmptyC
								image="/images/empty/address-list.svg"
								title="Belum ada lowongan tersedia"
								buttonText=""
								buttonHidden
							/>
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default PageContainer;
